import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import HotelsIconV2 from "@/components/icons/HotelsIconV2"
import LocationV2Icon from "@/components/icons/LocationV2Icon"
import StarIcon from "@/components/icons/StartIcon"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { Card, CardProps, Col, Row, Tag, theme, Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { Fragment } from "react/jsx-runtime"

const HotelGoodPriceItem = ({ product, ...props }: CardProps & { product: any }) => {
  const { getFormatCurrency } = useTETranslation()
  const token = theme.useToken().token
  const { i18n } = useTranslation()

  if (!product?.hotelCard || !product?.hotelCard?.searchHotelId) {
    return <Fragment />
  }

  return (
    <Card
      hoverable
      className="hotels__goodprices--item"
      onClick={() => {
        const checkIn = dayjs().add(dayjs().endOf("month").get("date"), 'day')
        const url = `/${i18n.language}/hotels/result/detail/${product?.hotelCard?.hotelId}/${product?.hotelCard?.searchHotelId}?adt=2&child=0&room=1&in=${checkIn.format("YYYY-MM-DD")}&out=${checkIn.add(1, 'day').format("YYYY-MM-DD")}&loc=${product?.hotelCard?.hotelId}&type=HOTEL&renew=true`
        window.open(url, '_blank')
      }}
      cover={
        <div style={{ height: "200px", overflow: "hidden", background: token.colorFillTertiary }}>
          {!!product?.hotelCard?.thumbnail ? (
            <img
              alt={product?.hotelCard?.hotelName ? `Khách sạn ${product.hotelCard.hotelName}` : "Khách sạn giá tốt"}
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
              src={product?.hotelCard?.thumbnail}
            />
          ) : (
            <Row justify="center" align="middle" style={{ height: "100%" }}>
              <HotelsIconV2 style={{ fontSize: "3.2rem", color: token.colorTextDisabled }} />
            </Row>
          )}
        </div>
      }
      style={{
        minHeight: '100%'
      }}
      styles={{
        ...props.styles,
        body: {
          padding: "1.2rem",
          display: "flex",
          flexDirection: "column",
          height: 'calc(100% - 200px)',
          ...(props.styles as any)?.body,
        },
      }}
      {...props}
    >
      <Row style={{ minHeight: '17rem' }}>
        <Col span={24}>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Title ellipsis={{ tooltip: true }} level={5} className="hotels__goodprices--item-name" style={{ margin: 0 }}>
              {product?.hotelCard?.hotelName}
            </Title>
          </Row>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Text ellipsis={{ tooltip: true }} style={{ width: '100%' }} className="hotels__goodprices--item-location">
              <Text ellipsis style={{ width: '100%', display: 'block' }}><LocationV2Icon style={{ fontSize: "1.6rem" }} />{" "} {product?.hotelCard?.location}</Text>
            </Text>
          </Row>
          <Row>
            <Text className="home__deals-hotels--item-star">
              {Array(Math.ceil(product?.hotelCard?.rating?.star || 1)).fill(null).map((_, idx) => {
                return (
                  <StarIcon key={idx} style={{ fontSize: "1.6rem", marginRight: '0.2rem' }} />
                )
              })}
            </Text>
          </Row>
          <Row>
            <Typography className="hotels__goodprices--item-review">
              <Text className="hotel__comments--feedback">{product?.hotelCard?.rating?.reviewScore}</Text>
              {' '}<Text strong type='secondary'>{product?.hotelCard?.rating?.reviewText}</Text>
              {' '}<Text>({product?.hotelCard?.rating?.totalReview} đánh giá)</Text>
            </Typography>
          </Row>
        </Col>
        <Col style={{ alignSelf: 'end' }} span={24}>
          <Row justify="end">
            <Text type='secondary' strong delete style={{ textAlign: 'end' }} className="hotels__goodprices--item-baseprice">
              {getFormatCurrency(parseFloat(product?.hotelCard?.pricing?.originalPrice || "0"))}
            </Text>
          </Row>
          <Row align="middle" gutter={[10, 10]} justify="end">
            <Col>
              <Text strong style={{ textAlign: 'end' }} className="hotels__goodprices--item-saleprice">
                {getFormatCurrency(parseFloat(product?.hotelCard?.pricing?.priceAfterHotelDiscount || "0"))}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Card
                size='small'
                styles={{
                  body: {
                    padding: '1rem',
                    paddingBlock: '0.5rem'
                  }
                }}
              >
                <Row align='middle' justify='space-between' wrap={false}>
                  <Col>
                    <Typography className="hotels__goodprices--item-vcode">
                      Mã: <Text className="hotels__goodprices--item-code" ellipsis={{ tooltip: true }} style={{ color: token.colorPrimary }} strong>{product?.hotelCard?.pricing?.voucher?.voucherCode}</Text><Tag color={token.colorPrimary} variant='solid'>{product?.hotelCard?.pricing?.voucher?.discountPercent}%</Tag>
                    </Typography>
                  </Col>
                  <Col>
                    <Text className="hotels__goodprices--item-finalprice" type='danger' strong style={{ textAlign: 'end' }}>
                      {getFormatCurrency((parseFloat(product?.hotelCard?.pricing?.priceAfterHotelDiscount || "0") / 100) * (100 - parseFloat(product?.hotelCard?.pricing?.voucher?.discountPercent || "0")))}
                    </Text>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default HotelGoodPriceItem